
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class DeleteConfirmModal extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  }) visible!: boolean;

  handleConfirm() {
    this.$emit('confirm');
  }

  handleCancel() {
    this.$emit('cancel');
  }

  handleMaskClick() {
    this.$emit('cancel');
  }
}
